function BottomSpacer() {
  return <div className="h-15 block md:h-5" />;
}

export default BottomSpacer;
